angular.module('SpidApp')

.controller('MoneyTransferController',
        ['$scope', 'MoneyTransfer', 'Toaster', 'MoneyTransferService', 'User', 'ConfigService', 'RouteSupervisor','$rootScope',
function ($scope,   MoneyTransfer,   Toaster,   MoneyTransferService,   User,   ConfigService,   RouteSupervisor,$rootScope) {
    $scope.currentAmount = 0;
    return ConfigService.all().then(function (config) {
    	
    	$scope.sort = 'moneyTransfer.updated_at';
        $scope.asc = true;
        $scope.agencyId = config.agencyId;
    	
        var loadNewMoneyTransfer = function () {
            $scope.outboundMoneyTransfer = new MoneyTransfer({
                  from        : MoneyTransfer.sources.SAFE
                , to          : MoneyTransfer.sources.OUT
                , amount      : null
                , destination : null
                , current	  : null
                , agency_id   : config.agencyId
                , user_id     : User.me().id
            });
            
            $scope.inboundMoneyTransfer = new MoneyTransfer({
                  from        : MoneyTransfer.sources.OUT
                , to          : MoneyTransfer.sources.SAFE
                , amount      : null
                , destination : null
                , current	  : null
                , agency_id   : config.agencyId
                , user_id     : User.me().id
            });
        };

        loadNewMoneyTransfer();

        $scope.performMoneyTransfer = function (moneyTransfer) {
            if(moneyTransfer.to === MoneyTransfer.sources.OUT){
                moneyTransfer.current = +$scope.currentAmount - (+moneyTransfer.amount);
            } else {
                moneyTransfer.current = +$scope.currentAmount + (+moneyTransfer.amount);
            }

            $scope.currentAmount = moneyTransfer.current;

            MoneyTransferService.save(config.agencyId, moneyTransfer).then(function () {
                Toaster.show('Le transfer d\'argent a été effectué');
                loadNewMoneyTransfer();
            })
        };

        $rootScope.$on('$stateChangeStart',
            function(){
                MoneyTransferService.findByAgencyId(config.agencyId).then(function (listeMoneyTransfer) {
                    $scope.moneyTransfers = listeMoneyTransfer;
                });
            }
        );




        $scope.$on('changeRoleEvent', function(event, args) {
        	RouteSupervisor.bounce(event, args.role);
        });
    })
}]);